export default __webpack_public_path__ + "static/media/digitallibrary.a207a86d.svg";